import { createAction } from "../../actions/actionUtils.js";
import { CORE, WATCHERS } from "../../actions/actionConstants.js";

const getCore = () => createAction(CORE.GET);
const resetWatchers = () => createAction(WATCHERS.RESET);

export const corePartRefreshAction = (actionEntity, atType, refreshAccount) => {
  // in future should implement the ability to refresh the whole core suite
  if (!actionEntity || !atType) {
    console.warn(
      "coreDataRefreshSaga :: action.payload must include valid actionEntity and atType params"
    );
    return null;
  }

  return createAction(CORE.PART_REFRESH, {
    parts: [{ actionEntity, atType }],
    refreshAccount
  });
};

export const corePartsRefreshAction = (parts, refreshAccount) => {
  // in future should implement the ability to refresh the whole core suite
  if (!parts || parts.length < 1) {
    console.warn(
      "coreDataRefreshSaga :: action.payload must include a valid parts param"
    );
    return null;
  }

  return createAction(CORE.PART_REFRESH, {
    parts,
    refreshAccount
  });
};

export const coreFullRefreshAction = refreshAccount => {
  return createAction(CORE.FULL_REFRESH, { refreshAccount });
};

// using the following export pattern so we can mock more easily using jest

const coreActions = {
  getCore,
  corePartRefreshAction,
  corePartsRefreshAction,
  coreFullRefreshAction,
  resetWatchers
};

export default coreActions;
